import { render, staticRenderFns } from "./CoingeckoIdLookupPage.vue?vue&type=template&id=0be2a3c2&"
import script from "./CoingeckoIdLookupPage.vue?vue&type=script&lang=js&"
export * from "./CoingeckoIdLookupPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports